import { TextField } from "@fluentui/react/lib/TextField";

import { IEditNumberProps } from "./IEditNumberProps";
import { useEditNumber } from "./UseEditNumber";

export function EditNumber(props: IEditNumberProps): JSX.Element {
  const {
    htmlId, prefix, suffix, disabled
  } = props;
  const {
    errorMessage, value, onBlur, onChange, onGetErrorMessage
  } = useEditNumber(props);

  return (
    <TextField
      errorMessage={errorMessage}
      id={htmlId}
      onBlur={onBlur}
      onChange={onChange}
      onGetErrorMessage={onGetErrorMessage}
      prefix={prefix}
      suffix={suffix}
      value={value}
      disabled={disabled}
    />
  );
}
